var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"item center"},[_c('img',{staticStyle:{"width":"90%","margin-left":"5%"},attrs:{"src":_vm.bannerImg}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }